import React from 'react';
import { useTable, usePagination, useSortBy } from 'react-table';


const LeadsTable = ({
  data,
  totalRows,
  columns,
  page,
  pageSize,
  setPage,
  setPageSize,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  search,
  setSearch,
}) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      manualPagination: true,
      manualSortBy: true,
      pageCount: Math.ceil(totalRows / pageSize),
      initialState: { pageIndex: page, pageSize },
    },
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page: tablePage,
    prepareRow,
    gotoPage,
    setPageSize: setTablePageSize,
    state: { pageIndex },
  } = tableInstance;

  return (
    <div>
      <input
        placeholder="Search..."
        value={search}
        onChange={(e) => {
          setPage(0);
          setSearch(e.target.value);
        }}
      />

      <table {...getTableProps()} border="1" cellPadding={5} style={{ width: '100%' }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  onClick={() => {
                    const isAsc = sortBy === column.id && sortOrder === 'asc';
                    setSortBy(column.id);
                    setSortOrder(isAsc ? 'desc' : 'asc');
                  }}
                >
                  {column.render('Header')}
                  {sortBy === column.id ? (sortOrder === 'asc' ? ' 🔼' : ' 🔽') : ''}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {tablePage.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => <td {...cell.getCellProps()}>{cell.render('Cell')}</td>)}
              </tr>
            );
          })}
        </tbody>
      </table>

      <div style={{ marginTop: '10px' }}>
        <button onClick={() => gotoPage(0)} disabled={pageIndex === 0}>
          First
        </button>
        <button onClick={() => gotoPage(pageIndex - 1)} disabled={pageIndex === 0}>
          Previous
        </button>
        <span>
          Page {pageIndex + 1} of {Math.ceil(totalRows / pageSize)}
        </span>
        <button
          onClick={() => gotoPage(pageIndex + 1)}
          disabled={pageIndex + 1 >= Math.ceil(totalRows / pageSize)}
        >
          Next
        </button>
        <button
          onClick={() => gotoPage(Math.ceil(totalRows / pageSize) - 1)}
          disabled={pageIndex + 1 >= Math.ceil(totalRows / pageSize)}
        >
          Last
        </button>
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setTablePageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 50].map(size => (
            <option key={size} value={size}>Show {size}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LeadsTable;
